<template>
    <div :class="{'modal':true,'selectColorModal':true,'modal--active':visible}" ref="selectColorModal">
        <div class="modal__content">
            <div class="grid-2">
                <div class="col-2 col-sm-1"><div class="color-square-wrapper"><color-square :color="selectModalColor"></color-square></div></div>
                <div class="col-2 col-sm-1">
                    <dropdown v-model="modalColorMode" :options="$store.state.colorDisplayModeList" displace></dropdown>
                    <div class="modal__input-wrapper">
                        <div v-if="modalColorMode=='hex'">
                            <label for="selectModalColorHex">{{modalColorMode}}</label>
                            <input type="text" id="selectModalColorHex" v-model.lazy="selectModalColor[modalColorMode]">
                        </div>
                        <div v-else>
                            <div v-for="i in 3" :key="i">
                                <label for="selectModalColor1">{{colorToggleConfig.headers[i-1]}}</label>
                                <input-number 
                                    v-model.number="modalColorValue[i-1]"
                                    :max="colorToggleConfig.max[i-1]"
                                    :min="colorToggleConfig.min[i-1]"></input-number>
                            </div>
                        </div>
                        <div class="button button--primary--solid" @click="confirmModalColor">OK</div>
                        <div class="button button--secondary--solid" @click="closeModal">Cancel</div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import colorSquare from "@/components/colorSquare.vue";
    import dropdown from "@/components/dropdown"
    import inputNumber from "@/components/input-number"
    export default {
        props:{
            visible:{
                type:Boolean,
                default:false
            },
            color:{
                type:Object
            }
        },
        data(){
            return {
                selectModalColor:null,
                modalColorValue:[0,0,0],
                modalColorMode:"hex"
            }
        },
        components:{
            colorSquare,
            dropdown,
            inputNumber,
        },
        computed:{
            colorToggleConfig(){
                return this.$store.state.colorToggleConfig[this.modalColorMode]
            },
        },
        methods:{
            closeModal(){
                this.$emit("update:visible",false);
            },
            confirmModalColor(){
                const newColor = new this.$store.state.Color({color:this.selectModalColor.rgb.map((n)=>Math.max(0, Math.min(255, n)))});
                this.$emit("update:color",newColor);
                this.closeModal();
            }
        },
        watch:{
            color:{
                immediate:true,
                deep:true,
                handler(color){
                    this.selectModalColor = new this.$store.state.Color({color:[...color.rgb]});
                }
            },
            modalColorMode:{
                immediate:true,
                handler(){
                    this.modalColorValue = this.selectModalColor[this.modalColorMode];
                }
            },
            modalColorValue:{
                deep:true,
                handler(){
                    this.selectModalColor[this.modalColorMode] = this.modalColorValue;
                }
            }
        }
    }
</script>
<style lang="scss">
    .selectColorModal .modal__content{
        padding: 2em;
        text-align: center;
    }
    .selectColorModal .dropdown{
        margin: 2% 0 5% 0;
    }
    .selectColorModal .modal__content label{
        text-align: center;
        text-transform: uppercase;
        font-size: 1.1em;
        width: 100%;
        display: block;
        margin: 2% 0;
    }
    .selectColorModal .modal__content input[type='text']{
        text-align: center;
        width: 100%;
    }
    .selectColorModal .button{
        margin: 2% 0 0 0;
        width: 100%;
        font-weight: 300;
        text-transform: uppercase;
        letter-spacing: 0.05em;
    }
    .selectColorModal .color-square-wrapper{
        display: flex; 
        align-items: center;
        height: 100%;
        margin: 0;
    }

    @media screen and (min-width: 768px){
        .selectColorModal .button{
            width: unset;
            margin: 5% 2% 0 2%;
        }
    }
    .modal{
        position:fixed;
        width:100%;
        height:100vh;

        transition: background-color 0.3s ease-in-out;
        background-color:transparent;
        z-index:555555555555555;
        display:none;
        top:0;
        left:0;
        right:0;
        bottom:0;
        align-items:center;
        justify-content:center;
    }
    .modal--active{
        background-color:rgba(0,0,0,0.5);
        display:flex;
    }
    .modal__close{
        position:fixed;
        top:5%;
        right:5%;
        z-index:999999999999999;
        color:#FFF;
        font-size:26px;
        cursor:pointer;
    }
    .modal__close span{
        background-color: #FFF;
        width: 40px;
        height: 5px;
        position: relative;
        display: block;
    }
    .modal__close span:first-of-type{
        transform: rotate(45deg);
        top: 2.5px;
    }
    .modal__close span:last-of-type{
        transform: rotate(-45deg);
        bottom: 2.5px;
    }
    .modal__content{
        z-index:999999999999999;
        width:90%;
        background-color:#FFF;
        padding:10px;
        border-radius:3px;
        box-sizing:border-box;
        max-width:900px;
        max-height: 90vh;
        overflow-y: scroll;
        margin-top: 10%;
    }
    @media screen and (min-width: 870px){    
        .modal__content{
            max-height: 100vh;
            margin-top: 0;
        }
    }
</style>